
let theMonths = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December',
];
let shorterMonths = [
	'Jan',
	'Feb',
	'Mar',
	'Apr',
	'May',
	'June',
	'July',
	'Aug',
	'Sept',
	'Oct',
	'Nov',
	'Dec',
];

const errorMessage =
	'There was an error finding your order! Please verify your number and email and try again. If the problem persists, please try again later, as it could be an issue with our tracking provider.';

const setErrorMessage = (value = '') =>
	(document.getElementById('tracking-error').innerText = value);

const fetchProduct = (handle) => {
	return new Promise((resolve) => {
		fetch(`/products/${handle}.json`)
			.then((res) => res.json())
			.then((response) => {
				resolve(response);
			})
			.catch((err) => {
				resolve(err);
			});
	});
};

const buildItems = (tracking) => {
	let lineItems = ``;
	let promises = [];
	let lines = tracking.shop_order.orders[0].line_items;
	if (tracking.products) {
		// DO NOTHING
	} else {
		lines.forEach((line) => {
			//  console.log(line);
			let handle = line.title
				.toLowerCase()
				.replace(/ /g, '-')
				.replaceAll('---', '-');
			promises.push(fetchProduct(handle));
		});
	}
	Promise.all(promises).then((results) => {
		let orderLines = ``;
		results.forEach((result, index) => {
			//  console.log(index);
			if (result.product) {
				let vTitle = ``;
				if (lines[index].variant_title) {
					vTitle = lines[index].variant_title;
				}

				lineItems += `
					<div class="ordered-product__line-items">
						<div class="ordered-product__container grid gap1 ai-center">
							<div>
								<img alt="" src="${result.product.image.src}">
							</div>
							<div class="ordered-product__details">
								<div class="ordered-product__detail uppercase small full-width">
									<h3 class="bold">
										${result.product.title}
									</h3>
									<p>
										${vTitle}
									</p>
									<p class="bold"></p>
								</div>
								<div class="ordered-product__quantity full-width">
									<p class="uppercase">
										Quantity: ${lines[index].quantity}
									</p>
								</div>
							</div>
						</div>
					</div>
				`;
			}
		});

		if (tracking.products) {
			document.getElementById('ordered-products__items').innerHTML = `${
				Object.values(tracking.products.data).length
			} ${
				Object.values(tracking.products.data).length === 1 ? 'ITEM' : 'ITEMS'
			}`;
			let productValues = Object.values(tracking.products.data);
			productValues.forEach((product, index) => {
				lineItems += `
					<div class="ordered-product__line-items">
						<div class="ordered-product__container grid gap1 ai-center">
							<div>
								<img alt="" src="${product.featuredImage.src}">
							</div>
							<div class="ordered-product__details">
								<div class="ordered-product__detail uppercase small full-width">
									<h3 class="bold">
										${product.title}
									</h3>
									<p>
										${tracking.shop_order.orders[0].line_items[index].variant_title}
									</p>
									<p class="bold">
										$${tracking.shop_order.orders[0].line_items[index].price}
									</p>
								</div>
								<div class="ordered-product__quantity full-width">
									<p class="uppercase">
										Quantity: ${tracking.shop_order.orders[0].line_items[index].quantity}
									</p>
								</div>
							</div>
						</div>
					</div>
				`;
			});
		}

		getTrackingUpsells(Object.values(tracking.products.data));
		return (document.getElementById('in-this-order').innerHTML = lineItems);
	});
};

let rowStyle;

const buildCalendar = (date) => {
	let hasDate = true;
	let exp;
	if (date == null) {
		hasDate = false;
		date = new Date(Date.now());
		date = date.getTime() + Math.abs(date.getTimezoneOffset() * 60000);
		exp = new Date(date);
		date = `${exp.getYear()}-${exp.getDate()}-${exp.getMonth() + 1}`;
	} else {
		exp = new Date(date);
	}

	let days = [
		'Sunday',
		'Monday',
		'Tuesday',
		'Wednesday',
		'Thursday',
		'Friday',
		'Saturday',
	];

	let expected = new Date(
		exp.getTime() + Math.abs(exp.getTimezoneOffset() * 60000)
	);
	let dateValues = date.split('-');
	let year = dateValues[0];
	let month = dateValues[1];
	let first = new Date(`${year}-${month}-01`);
	let actual = new Date(
		first.getTime() + Math.abs(first.getTimezoneOffset() * 60000)
	);
	let day = actual.getDay();
	let totalDays = new Date(year, month, 0).getDate();
	let expDate = expected.getDate();
	let expDay = days[expected.getDay()];
	let expMon = months[expected.getMonth()];
	let today = Date.now() + Math.abs(first.getTimezoneOffset() * 60000);
	let daysUntil = Math.ceil((expected - today) / (1000 * 3600 * 24));

	expectedMessage = `expected arrival in ${daysUntil} days`;
	if (daysUntil == 0) {
		expectedMessage = `expected arrival today`;
	} else if (daysUntil < 0) {
		expectedMessage = `Delivered`;
	}

	if (hasDate == false) {
		expectedMessage = `we're still waiting for the carrier to fill us in. check back again soon!`;
		expDate = '';
		expDay = '';
	}

	//  console.log(date
	let calendar = `
<div>
<p class="uppercase small m-standard">${expectedMessage}</p>
<p class="subheading uppercase">${expDay}: <span class="bold">${expMon} ${expDate}</span></p>
</div>
<div id="tracking-calendar-grid" class="full-height grid text-center ai-center jc-center" style="grid-template-columns:repeat(7, 1fr);">
<div class="background-color--secondary flex ai-center jc-center full-height bold" style="min-height:3rem;">S</div>
<div class="background-color--secondary flex ai-center jc-center full-height bold" style="min-height:3rem;">M</div>
<div class="background-color--secondary flex ai-center jc-center full-height bold" style="min-height:3rem;">T</div>
<div class="background-color--secondary flex ai-center jc-center full-height bold" style="min-height:3rem;">W</div>
<div class="background-color--secondary flex ai-center jc-center full-height bold" style="min-height:3rem;">T</div>
<div class="background-color--secondary flex ai-center jc-center full-height bold" style="min-height:3rem;">F</div>
<div class="background-color--secondary flex ai-center jc-center full-height bold" style="min-height:3rem;">S</div>
`;

let totalItems = 0;

	for (i = 0; i < day; i++) {
		calendar += `<div class="background-color--secondary full-height"></div>`;
		totalItems += 1;
	}

	for (i = 1; i <= totalDays; i++) {
		if (i == expDate) {
			calendar += `<div class="background-color--secondary full-height"><div class="flex ai-center jc-center full-height" style="max-height:2rem; background-position:center center; background-repeat:no-repeat; background-image:url(https://assets.narvar.com/retailers/birdygrey/Pink-heart.png) !important;">${i}</div></div>`;
		} else {
			calendar += `<div class="background-color--secondary full-height"><div class="flex ai-center jc-center full-height" style="max-height:2rem;">${i}</div></div>`;
		}
		totalItems += 1;
	}
fillDays = totalItems % 7;
if (fillDays !== 0) {
	fillDays = 7 - fillDays;
}
let rows = Math.ceil(totalItems / 7);
for (i=1; i <= fillDays; i++) {
calendar += `<div class="flex ai-center jc-center background-color--secondary full-height" style="min-height:2rem; "></div>`
}
rowStyle = `3rem`;
for (i=1; i < rows; i++) {
	rowStyle += ` 2rem`;
}
rowStyle += ` auto`;

	return calendar;
};

const buildStatus = (tracking) => {
	let trackings = ``;
	let icon = ``;
	let checkpoints = tracking.checkpoints.reverse();

	checkpoints.forEach((checkpoint) => {
		let checkDate = new Date(checkpoint.checkpoint_time);
		let checkD = checkDate.getDate();
		let checkT = checkDate.getTime();
		let checkM = checkDate.getMonth();
		let checkLocation = checkpoint.location;
		if (checkpoint.city && checkpoint.state) {
			checkLocation = `${checkpoint.city}, ${checkpoint.state}`;
		} else if (checkpoint.country_name) {
			checkLocation = `${checkpoint.country_name}`;
		}
		if (checkpoint.message == 'DELIVERED') {
			icon += `<div class="delivered-icon"></div>`;
		}
		trackings += `
<div class="grid gap1" style="grid-template-columns:1fr 3fr; border-top:1px solid #F2DCD9;">
<div class="grid ai-center">
<div>
<div>
${shorterMonths[checkM]} ${checkD}
</div>
<div>
${checkDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
</div>
</div>
</div>
<div class="grid ai-center" style="margin:1rem 0;">
<div>
<div>
${checkpoint.message}
</div>
<div>
${checkLocation}
</div>
</div>
</div>
</div>
    `;
	});

	const displayTrackingNumber = ({ slug = null, trackingNumber = 0 }) => {
		return Boolean(trackingNumber !== 0 && slug)
			? `
				<div class="grid gap1" style="border-top:1px solid #F2DCD9;">
					<div class="">
						<p>${slug?.toUpperCase() ?? ''} Tracking Number<br/>${trackingNumber}</p>
					</div>
				</div>
			`
			: '';
	};

	trackings += displayTrackingNumber({
		slug: tracking?.slug,
		trackingNumber: tracking?.tracking_number,
	});
	
	let recentMessage = ``;
	if (checkpoints.length > 0) {
		recentMessage = checkpoints[0].message;
	} else {
		recentMessage = `Your package is currently being processed. We'll update with a status as soon as we receive one from the carrier.`;
	}

	return {
		recentMessage,
		trackings,
	};
};

const trackOrder = (number, email) => {
	fetch(`/apps/get-tracking`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'X-Requested-With': 'XMLHttpRequest',
			'Access-Control-Allow-Credentials': true,
		},
		body: JSON.stringify({ tracking: number, email: email }),
	})
		.then((res) => res.json())
		.then((response) => {
			if (response.message) {
				window.location.replace('/pages/tracking');
				document
					.getElementById('track-order-button')
					.addEventListener('click', sendTracking);
				return;
			}

			let state = { new_tracking: response.id };
			let title = 'TRACKING';
			let emailAdd = '';
			if (response.shop_order) {
				emailAdd = response.shop_order.orders[0].email;
			}
			let url = `/pages/tracking?tracking=${response.tracking_number}&order=${response.order_number}`;
			history.replaceState(state, title, url);
			let calendar = buildCalendar(response.expected_delivery);
			const { recentMessage, trackings } = buildStatus(response);
			document.getElementById('calendar').innerHTML = calendar;
			document.getElementById('tracking-calendar-grid').style.gridTemplateRows = rowStyle;
			document.getElementById('tracking__recentMessage').innerHTML =
				recentMessage;
			document.getElementById('tracking__status').innerHTML = trackings;
			if (response.shop_order) {
				buildItems(response);
			}
			document.getElementById('tracking-page').classList.add('show-tracking');
		})
		.catch((err) => {
			// console.log('ERROR!');
			// console.log(err);
		});
};

const fetchOrder = (number, email) => {
	fetch(`/apps/get-tracking/get-order`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'X-Requested-With': 'XMLHttpRequest',
			'Access-Control-Allow-Credentials': true,
		},
		body: JSON.stringify({ order: number, email: email.toLowerCase() }),
	})
		.then((res) => res.json())
		.then((response) => {
			if (response.message) {
				document.getElementById('track-order-button').innerText = 'TRACK ORDER';
				setErrorMessage(errorMessage);

				document
					.getElementById('track-order-button')
					.addEventListener('click', sendTracking);
				return;
			}

			let state = { new_tracking: response.id };
			let title = 'TRACKING';
			let url = `/pages/tracking?tracking=${response.tracking_number}&order=${response.order_id}`;
			window.location.replace(url);
			history.replaceState(state, title, url);

			let calendar = buildCalendar(response.expected_delivery);
			const { recentMessage, trackings } = buildStatus(response);
			document.getElementById('calendar').innerHTML = calendar;
			document.getElementById('tracking__recentMessage').innerHTML =
				recentMessage;
			document.getElementById('tracking__status').innerHTML = trackings;
			if (response.shop_order) {
				buildItems(response);
			}
		})
		.catch((err) => {
			// console.log('ERROR!');
			// console.log(err);
		});
	document.getElementById('tracking-page').classList.add('show-tracking');
};

const sendTracking = () => {
	let input = document.getElementById('tracking-number-input');
	let email = document.getElementById('tracking-email-input');
	setErrorMessage('');
	if (input && input.value.length > 0 && email && email.value.length > 0) {
		document.getElementById('track-order-button').innerText =
			'GETTING ORDER...';
		document
			.getElementById('track-order-button')
			.removeEventListener('click', sendTracking);
		fetchOrder(input.value, email.value);
	} else {
		setErrorMessage('Please input required fields.');
		setTimeout(() => setErrorMessage(''), 2000)
	}
};

let urlParams = new URLSearchParams(window.location.search);
let theparams = Object.fromEntries(urlParams.entries());

if (theparams.order && theparams.email && theparams.email !== undefined) {
	fetchOrder(theparams.order, theparams.email);
} else if (theparams.tracking) {
	trackOrder(theparams.tracking);
} else {
	document
		.getElementById('track-order-button')
		.addEventListener('click', sendTracking);
}